import { callAPI, HTTPMethod } from "./API";
import {NonIntegratedCfdiParams, RequestCancellationParams} from "../model/CfdisNonIntegrated";
import { ExportResponse } from "../model/Connector";

const basePath = (tenantId: string) => `/tenants/${tenantId}/non-integrated-cfdis`;

export async function exportExcel(tenantId: string, params: NonIntegratedCfdiParams) : Promise<ExportResponse> {
    return await callAPI(`${basePath(tenantId)}/export`, {
        method: HTTPMethod.POST,
        body: params
    });
}

export async function requestCancellation(tenantId: string, params: RequestCancellationParams): Promise<void> {
    return await callAPI(`${basePath(tenantId)}/request-cancellation`, {
        method: HTTPMethod.PUT,
        body: params
    });
}

export async function revokeCancellationRequest(tenantId: string, cfdiId: string): Promise<void> {
    return await callAPI(`${basePath(tenantId)}/revoke-cancellation/${cfdiId}`, {
        method: HTTPMethod.PUT
    });
}
